import React from 'react';

import Button, { ButtonProps } from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WaitingButton, { WaitingButtonProps } from 'cityads-v3/components/Buttons/WaitingButton';

type ConfirmProps = Pick<DialogProps, 'onClose'> & {
  open?: boolean
  yes: string
  no: string
  onYes: (...args: unknown[]) => void
  onNo: (...args: unknown[]) => void
  text: string | React.ReactNode
  title?: string
  yesButtonProps?: WaitingButtonProps
  noButtonProps?: ButtonProps
  dialogProps?: Partial<DialogProps>
}

export default function Confirm({
  open,
  title,
  text,
  onNo,
  onYes,
  onClose,
  no,
  yes,
  yesButtonProps,
  noButtonProps,
  dialogProps,
}: ConfirmProps): JSX.Element {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      {...dialogProps}
    >
      {title ? (
        <DialogTitle>
          {title}
        </DialogTitle>
      ) : false}

      {text ? (
        <DialogContent>
          <DialogContentText component="div">
            {text}
          </DialogContentText>
        </DialogContent>
      ) : false}

      <DialogActions>
        <Button
          variant="text"
          onClick={onNo}
          {...noButtonProps}
        >{no}</Button>
        <WaitingButton
          variant="contained"
          color="primary"
          onClick={onYes}
          {...yesButtonProps}
        >{yes}</WaitingButton>
      </DialogActions>
    </Dialog>
  );
}
